import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import { useParams, useNavigate } from "react-router-dom";
// import Classes from "../Assets/image321.png";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer";
import { getAllCourse, getdaysCourse } from "../Common/apis.js";
import { toast } from "react-toastify";

function BookClasses() {
  const [course, setCourse] = useState([]);
  const [loginupdate, setloginupdate] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date().toDateString());
  const navigate = useNavigate();

  const handleNavigation = (classId) => {
    console.log(classId);
    const token = localStorage.getItem("AluraToken");

    if (!token) {
      toast.error("Please login to continue!");
      setloginupdate(loginupdate + 1);
    } else {
      const dateObj = new Date(selectedDate);
      const formattedDate = `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${dateObj.getDate().toString().padStart(2, "0")}`;
      navigate(`/checkout/${classId}?date=${formattedDate}`);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await getdaysCourse();
      setCourse(result?.data);
    } catch (error) {}
  };

  // console.log(course);

  const today = new Date();

  // Function to format the date and get day name
  const getFormattedDate = (offset) => {
    const futureDate = new Date();
    futureDate.setDate(today.getDate() + offset);

    const options = { weekday: "short" }; // Get day abbreviation (e.g., Sun, Mon)
    return {
      date: futureDate.getDate(),
      day: futureDate.toLocaleDateString("en-US", options)
    };
  };

  // Generate an array of the next 14 days
  const dateArray = Array.from({ length: 14 }, (_, index) =>
    getFormattedDate(index)
  );

  return (
    <>
      <Navbar loginupdate={loginupdate} />
      <div className="aboutbanner aboutbanner4">
        <h3>Book Classes</h3>
        <p>HOME - BOOK CLASSES</p>
      </div>
      <div className="ClassSchedule">
        <h3>Class Schedule</h3>
        <br />
        {/* <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
          varius enim in eros elementum tristique. Duis cursus, mi quis viverra
          ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.
        </p> */}
        {/* <br />
        <br /> */}

        <h4 style={{ textAlign: "center" }}>
          {today.toLocaleDateString("en-US", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric"
          })}
        </h4>
        <br />

        <div className="date-div">
          {/* {dateArray.map((item, index) => (
            <div>
              <div key={index} className="date">
                <h3>{item.date}</h3>
                <p>{item.day}</p>
              </div>
            </div>
          ))} */}
          {dateArray.map((item, index) => {
            const fullDate = new Date();
            fullDate.setDate(today.getDate() + index);
            const dateString = fullDate.toDateString();

            return (
              <div>
                <div
                  key={index}
                  className={`date ${
                    selectedDate === dateString ? "active" : ""
                  }`}
                  onClick={() => setSelectedDate(dateString)}
                  style={{ cursor: "pointer" }}
                >
                  <h3>{item.date}</h3>
                  <p>{item.day}</p>
                </div>
              </div>
            );
          })}
        </div>
        <br />
        <br />
        <br />

        <h4>All Classes</h4>
        <br />
        <br />
        <div className="All-Classes">
          {course.length > 0 ? (
            course
              .filter((cls) => {
                return cls?.schedule?.some((schDate) => {
                  // const formattedScheduleDate = new Date(
                  //   schDate?.date
                  // ).toDateString();
                  // return formattedScheduleDate === selectedDate;
                  const scheduleDate = new Date(schDate.date);
                  const scheduleDateStr = scheduleDate.toDateString();
                  const today = new Date();
                  const todayStr = today.toDateString();

                  if (scheduleDateStr !== selectedDate) return false;

                  // If selected date is today, check against time too
                  if (selectedDate === todayStr) {
                    // Combine date and startTime (assumes "HH:mm" format)
                    const [hours, minutes] = schDate.startTime
                      .split(":")
                      .map(Number);
                    const sessionDateTime = new Date(schDate.date);
                    sessionDateTime.setHours(hours, minutes, 0, 0);

                    return sessionDateTime.getTime() >= Date.now();
                  }

                  return true;
                });
              })
              .sort((a, b) => {
                const aSession = a.schedule.find(
                  (s) => new Date(s.date).toDateString() === selectedDate
                );
                const bSession = b.schedule.find(
                  (s) => new Date(s.date).toDateString() === selectedDate
                );

                if (aSession && bSession) {
                  return aSession.startTime.localeCompare(bSession.startTime);
                }
                return 0;
              })
              .map((cls, index) => (
                <div key={index} className="All-Classes-card1">
                  <div className="All-Classes-card">
                    <div className="All-Classes-heading">
                      <h4>{cls.title}</h4>
                      {/* <p>{cls.description.slice(0, 100)}...</p> */}
                    </div>
                    {/* <br /> */}
                    {/* {cls.image && cls.image.length > 0 && (
                      <img
                        src={cls.image[0]}
                        alt={cls.title}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover"
                        }}
                      />
                    )} */}
                    {/* <br /> */}
                    {/* <br /> */}
                    {/* <div className="TIME" style={{marginTop:'5px'}}>
                      <h6 >Time</h6>
                      <h5 >
                        {new Date(cls.startTime).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true // Ensures AM/PM format
                        })}{" "}
                        -{" "}
                        {new Date(cls.endTime).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true
                        })}
                      </h5>
                    </div> */}
                    <div className="TIME" style={{ marginTop: "5px" }}>
                      <h6>Time</h6>
                      {cls.schedule
                        .filter(
                          (session) =>
                            new Date(session.date).toDateString() ===
                            selectedDate
                        )
                        .map((session, i) => (
                          <h5 key={i}>
                            {session.startTime} - {session.endTime}
                          </h5>
                        ))}
                    </div>

                    <br />
                    {/* <Link > */}
                    <button onClick={() => handleNavigation(cls._id)}>
                      Book Class
                    </button>
                    {/* </Link> */}
                  </div>
                </div>
              ))
          ) : (
            <p>No classes available</p>
          )}
          {/* <div className="All-Classes-card1">
            <div className="All-Classes-card">
              <div className="All-Classes-heading">
                <h4>Retreat – Escape, Recharge & Renew</h4>
                <p></p>
              </div>
              <br />
             
              <br />
              <div className="TIME">
                <h6>Time</h6>
                <h5>10:30AM - 12:30PM</h5>
              </div>
              <br />
              <Link to="/checkout">
                <button>Book Class</button>
              </Link>
            </div>
          </div>
          <div className="All-Classes-card1">
            <div className="All-Classes-card">
              <div className="All-Classes-heading">
                <h4>Fusion – The Best of Everything in One Class</h4>
                <p></p>
              </div>
              <br />
             
              <br />
              <div className="TIME">
                <h6>Time</h6>
                <h5>01:30PM - 03:30PM</h5>
              </div>
              <br />
              <Link to="/checkout">
                <button>Book Class</button>
              </Link>
            </div>
          </div>
          <div className="All-Classes-card1">
            <div className="All-Classes-card">
              <div className="All-Classes-heading">
                <h4>Meditation – Find Stillness, Clarity & Inner Peace</h4>
                <p></p>
              </div>
              <br />
             
              <br />
              <div className="TIME">
                <h6>Time</h6>
                <h5>04:30PM - 06:30PM</h5>
              </div>
              <br />
              <Link to="/checkout">
                <button>Book Class</button>
              </Link>
            </div>
          </div> */}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default BookClasses;
